import React, { useState } from 'react';
import { Button, TextField, Grid, Typography } from '@mui/material';
import sitelist from '../json/site-list.json';
import { isValidDatestr } from './validate';
import useFocus from './useFocus';

function ListingEntryRange(props) {
	const { updateListEntryData, updateListEntryRangeStatus, userEntryData } = props;
	const padStr = (val) => val.toString().padStart(2, "0");    //zero-pad a two-digit string representation of a number
	const crnt = new Date();
    const crntUTCstring = crnt.getUTCFullYear()+"-"+padStr((crnt.getUTCMonth()+1))+"-"+padStr(crnt.getUTCDate())+"T"+padStr(crnt.getUTCHours())+":"+padStr(crnt.getUTCMinutes());
	const [ obsdate, setObsdate ] = useState({startdate: "", enddate: crntUTCstring});
	const [ coopid, setCoopid ] = useState(userEntryData.coopid || "");
	const [ showError, setShowError ] = useState(false);

	const [ coopidToolRef, setCoopidFocus ] = useFocus();
	const [ startdateToolRef, setStartdateFocus ] = useFocus();
	const [ enddateToolRef, setEnddateFocus ] = useFocus();

	const handleIdChange = (event) => {
		const coopid = event.target.value.toUpperCase();
		setCoopid(coopid);
		setShowError(false); //clear error message when user starts to enter new value
	};

	const handleDateChange = (event) => {
		const value = event.target.value;
		const whichdate = event.target.name;
		setObsdate({...obsdate, [whichdate]:value});
		setShowError(false); //clear error message when user starts to enter new value
	};

	const handleClick = () => {
		const ids = sitelist[coopid] || [];
		if (!ids.length && coopid !== '*') {
			setShowError("This is not a valid cooperator id; please enter a different id.");
			setCoopid("");
			setCoopidFocus();
		} else if (!isValidDatestr(obsdate.startdate)) {
			setShowError("Invalid start date");
			setObsdate({...obsdate, startdate:""});
			setStartdateFocus();
		} else if (!isValidDatestr(obsdate.enddate)) {
			setShowError("Invalid end date");
			setObsdate({...obsdate, enddate:""});
			setEnddateFocus();
		} else {
			setShowError(false);
			updateListEntryData(coopid, obsdate, true);		//last arguement is weekChecked; true to get ALL_REPORTS
			updateListEntryRangeStatus(false);
		};
	};

	return (
		<>
			<form noValidate autoComplete="off">
				<Grid container direction="column" alignItems="center">
					<Grid container direction="row" alignItems="flex-start" justifyContent="center" spacing={3}>
						<Grid item>
							<TextField 
								required 
								autoFocus
								variant="outlined"
								value={coopid} 
								name="coopid"
								label="Cooperator ID" 
								onChange={handleIdChange}
								inputRef={coopidToolRef}
								onFocus={(event) => event.target.select()}
								helperText="Enter * for all"
							/>
						</Grid>
						<Grid item>
							<TextField 
								required 
								variant="outlined"
								value={obsdate.startdate} 
								name="startdate"
								label="Start date (UTC)" 
								onChange={handleDateChange}
								inputRef={startdateToolRef}
								onFocus={(event) => event.target.select()}
								placeholder="yyyy-MM-ddThh:mm"
							/>
						</Grid>
						<Grid item>
							<TextField 
								required 
								variant="outlined"
								value={obsdate.enddate} 
								name="enddate"
								label="End date (UTC)" 
								onChange={handleDateChange}
								inputRef={enddateToolRef}
								onFocus={(event) => event.target.select()}
								placeholder="yyyy-MM-ddThh:mm"
							/>
						</Grid>
					</Grid>

					<Grid item>
						{showError &&
							<Typography variant="body2" color="error" mt={1.5}>
								{showError}
							</Typography>
						}
					</Grid>
					
					<Grid item>
						<Button variant="contained" color="primary" onClick={handleClick}>
							Continue
						</Button>
					</Grid>
				</Grid>
			</form>
		</>
	);
}
export default ListingEntryRange;
